"use client";

import { cn } from "@/lib/utils";
import { FaWhatsapp } from "react-icons/fa";
import { buttonClass } from "./ui-tokens";

interface WhatsAppCTAProps {
  className?: string;
  /**
   * `solid` é o botão principal da vista; `outline` e `ghost` são
   * secundários; `glass` e `inverse` vão sobre a faixa escura (`--lp-band`).
   */
  variant?: "solid" | "outline" | "ghost" | "glass" | "inverse";
  size?: "sm" | "md" | "lg";
  text?: string;
  customMessage?: string;
  onClick?: () => void;
}

export default function WhatsAppCTA({
  className,
  variant = "solid",
  size = "md",
  text = "Quero Testar",
  customMessage,
  onClick,
}: WhatsAppCTAProps) {
  const phoneNumber = "5519993376029";
  const defaultMessage =
    "Olá! Vi o Ecclesiato e gostaria de testar uma conta de igreja.";
  const message = encodeURIComponent(customMessage || defaultMessage);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  const base =
    variant === "solid"
      ? buttonClass("primary", size === "lg" ? "lg" : "md")
      : variant === "outline"
        ? buttonClass("secondary", size === "lg" ? "lg" : "md")
        : variant === "glass"
          ? buttonClass("ghost-inverse", size === "lg" ? "lg" : "md")
          : variant === "inverse"
            ? buttonClass("inverse", size === "lg" ? "lg" : "md")
            : buttonClass("secondary", "md", "shadow-none ring-0 bg-transparent text-muted-foreground hover:text-foreground");

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={cn(base, size === "sm" && "h-10 px-4 text-sm", className)}
    >
      <FaWhatsapp className="size-4.5 shrink-0" aria-hidden="true" />
      {text}
      <span className="sr-only"> (abre o WhatsApp)</span>
    </a>
  );
}
